import { field } from "../../helpers";
import { fdaPmaTheme } from "../themes";

const fdaPmaConfig = {
  label: "FDA PMA",
  theme: fdaPmaTheme,
  summary: {
    primary: field("Trade name", ["trade_name", "generic_name"]),
    secondary: field("PMA number", ["pma_number"], { kind: "id" }),
    columns: [
      field("Applicant", ["applicant_name"], {
        className: "hidden lg:block flex-[1.25] min-w-[9rem]",
      }),
      field("Product code", ["product_code"], {
        className: "hidden md:block flex-[0.8] min-w-[6rem]",
        kind: "accent",
      }),
      field("Approval date", ["original_approval_date"], {
        className: "flex-[0.95] min-w-[7rem]",
      }),
      field("PMA Status", ["pma_status"], {
        className: "hidden xl:block flex-[1] min-w-[7rem]",
        kind: "status",
      }),
    ],
  },
  detail: {
    meta: [
      field("PMA number", ["pma_number"], { kind: "id" }),
      field("Product code", ["product_code"], { kind: "accent" }),
      field("Status", ["pma_status"], { kind: "status" }),
    ],
    sections: [
      {
        title: "Applicant",
        fields: [
          field("Company", ["applicant_name"]),
          field("Country", ["country"] ,   {includeMissing: true,
              missingValue: "Not available",
            }),
        ],
      },
      {
        title: "Device",
        fields: [
          field("Generic name", ["generic_name"]),
          field("Product Code", ["product_code"]),
          field("Device class", ["device_class"]),
          field("Regulation number", ["regulation_number"]),
          field("Advisory committee", ["advisory_committee_description"]),
        ],
      },
      {
        title: "Regulatory",
        fields: [
          field("Review track", ["review_track"]),
          field("First In Class", ["first_in_class"]),
          field("Breakthrough Designation", ["breakthrough_designation"]),
          field("Post-approval study", ["post_approval_study_required"]),
        ],
      },
    ],
    links: [
      {
        label: "Open PMA record",
        buildHref: (record, value) =>
          value
            ? `https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpma/pma.cfm?id=${value}`
            : "",
        sources: ["pma_number"],
        valueLabel: "",
      },
      {
        label: "SSED",
        buildHref: (record, value) => value || "",
        sources: ["ssed_url"],
        valueLabel: "Open SSED",
      },
      {
        label: "Approval letter",
        buildHref: (record, value) => value || "",
        sources: ["approval_letter_url"],
        valueLabel: "Open approval letter",
      },
      {
        label: "Approval letter",
        buildHref: (record, value) => value || "",
        sources: ["device_labeling_url"],
        valueLabel: "Open approval letter",
      },
    ],
  },
};

export default fdaPmaConfig;
